import { pickAuthoredText, type Locale, type Program } from "@heraion/shared";

import type { QueuedCreate } from "../seams";

// #475: the keys a copy answers to, the one rule for listed programs and
// plans, official items, and the host's queued creates (see
// usePendingProgramCopies). Pure, so the provider can read the queue with it.

export const nameKey = (name: string): string => `name:${name}`;
export const modelKey = (modelId: string): string => `model:${modelId}`;
export const planKey = (name: string): string => `plan:${name}`;

type CopySource = Pick<Program, "name" | "origin" | "authorLocale">;

/** The keys a listed program answers to. */
export function programCopyKeys(p: CopySource, lang: Locale): string[] {
  const name = pickAuthoredText(p.name, lang, p.authorLocale) ?? "";
  return [
    ...(name ? [nameKey(name)] : []),
    ...(p.origin?.modelId ? [modelKey(p.origin.modelId)] : []),
  ];
}

/** The keys an official item's copy will answer to. */
export const officialCopyKeys = (name: string, modelId?: string): string[] => [
  nameKey(name),
  ...(modelId ? [modelKey(modelId)] : []),
];

/** The keys a queued create answers to: a program or plan POST, by the
 *  rules above. Anything else answers to none. */
export function queuedCopyKeys(row: QueuedCreate, lang: Locale): string[] {
  const body = row.body;
  if (row.method !== "POST" || typeof body !== "object" || body === null) return [];
  if (row.path === "/api/me/programs") return programCopyKeys(body as CopySource, lang);
  const name = (body as { name?: unknown }).name;
  return row.path === "/api/me/plans" && typeof name === "string" && name
    ? [planKey(name)]
    : [];
}
